import { Component, Input } from '@angular/core';
import { FormControl, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormGroupComponent } from './form-group.component';
import { PriceComponent } from './price.component';


@Component({
    selector: 'form-price-range',
    imports: [
        FormGroupComponent,
        PriceComponent,
        FormsModule,
        ReactiveFormsModule,
    ],
    host: {
        class: 'd-block',
    },
    template: `
        <form-group>
            <ng-content select="label"></ng-content>
            <div class="form-range">
                <ui-price class="flex-grow-1" [attr.id]="formControlFrom" [formControl]="controlFrom"></ui-price>
                <span class="dash">&ndash;</span>
                <ui-price class="flex-grow-1" [attr.id]="formControlTo" [formControl]="controlTo"></ui-price>
            </div>
        </form-group>
    `,
})
export class FormPriceRangeComponent {

    @Input() formControlFrom: string;

    @Input() formControlTo: string;

    get controlFrom() {
        return this.formGroup.form.get(this.formControlFrom) as FormControl;
    }

    get controlTo() {
        return this.formGroup.form.get(this.formControlTo) as FormControl;
    }

    constructor(private formGroup: FormGroupDirective) {}
}
